// removed by extract-text-webpack-plugin
module.exports = {"header":"_2m9dqKWO5gZmmOzue7sI9G","header__inner":"e0PU_kC8YT8SNegSDf0Hz","header__center":"_3kpQWKgZiCB2leZxndUeYN","logo":"_2DPVOJAVVHrwW7PtN635k","header__search":"_3ukNykVqdCHLCOTiEOERt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.css
// module id = 118
// module chunks = 0